module.exports = __webpack_public_path__ + "img/gluten.c5aee5d7.svg";